import { observer } from "mobx-react-lite";
import MainLayout from "../MainLayout";
import { useNavigate } from "react-router-dom";
import { VerticalLayout } from "../../common/common-layout";
import { TitleLargeMedium } from "../../common/common-text";
import BTBox from "../../common/components/BTBox";
import BTList from "../../common/components/board/BTList";
import { GridRowParams } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import Post from "../../model/archive/Post";
import { formatDateToYMD } from "../../common/utils/DateUtils";
import { dialogStore } from '../../store/DialogStore';
import { fetchPosts, deletePost } from "../../common/firebase/Firestore";

const BBBoard = () => {
    return (
        <MainLayout>
            <BBBoardBody />
        </MainLayout>
    );
};

export default BBBoard;

const BBBoardBody = observer(() => {
    const boardName = 'bbboard'
    const navigate = useNavigate();
    const [posts, setPosts] = useState<Post[]>([]);
    const [selectedRows, setSelectedRows] = useState<number[]>([]); 

    useEffect(() => {
        async function loadData() {
            const posts = await fetchPosts(boardName);
            setPosts(posts);
        }

        loadData();
    }, []);


    const columns = [
        { field: 'id', headerName: '번호', width: 80, headerAlign: 'center', align: 'center' },
        { field: 'title', headerName: '제목', flex: 1, headerAlign: 'center', align: 'left' },
        { field: 'createdBy', headerName: '작성자', width: 100, headerAlign: 'center', align: 'center' },
        { field: 'createdDate', headerName: '게시일', width: 110, headerAlign: 'center', align: 'center' },
    ];

    const rows = posts.map((post, index) => ({
        id: posts.length - index,
        title: post.title,
        createdBy: post.createdBy,
        createdDate: formatDateToYMD(post.createdAt),
        originalPost: post,
    }));

    const handleRowClick = (params: GridRowParams): void => {
        const matchedPost = params.row.originalPost;
        if (matchedPost) {
            navigate('/archive/bbboard/detail', { state: matchedPost });
        }
    };

    const handleDeleteClick = async (selectedIndexes: number[]): Promise<void> => {
        if (selectedIndexes.length === 0) {
            dialogStore.showDialog({
                title: '알림',
                message: '삭제할 항목을 선택하세요.',
                onConfirm: () => {},
            });
            return;
        }
    
        dialogStore.showDialog({
            title: '알림',
            message: '정말 삭제하시겠습니까?',
            onConfirm: async () => {
                try {
                    const selectedPostIds = selectedIndexes.map(index => posts[index]?.id).filter(id => id);
    
                    for (const id of selectedPostIds) {
                        if (id) {
                            await deletePost(boardName, id);
                        }
                    }
    
                    const updatedPosts = await fetchPosts(boardName);
                    setPosts(updatedPosts);

                    setSelectedRows([]);
    
                    dialogStore.showDialog({
                        title: '성공',
                        message: '삭제가 완료되었습니다.',
                        onConfirm: () => {},
                    });
                } catch (error) {
                    console.error('삭제 오류:', error);
                    dialogStore.showDialog({
                        title: '오류',
                        message: '삭제 중 문제가 발생했습니다.',
                        onConfirm: () => {},
                    });
                }
            },
            onCancel: () => {
                console.log('삭제 취소');
            },
        });
    };
    
    return (
        <VerticalLayout height={'auto'} paddingLeft={36} paddingRight={36}>
            <TitleLargeMedium>BB게시판</TitleLargeMedium>
            <BTBox height='36px' />
            <div style={{ width: "100%" }}>
                <BTList
                    rows={rows}
                    columns={columns}
                    handleRowClick={handleRowClick}
                    onDeleteButtonClick={handleDeleteClick}
                    checkboxSelection={true}
                    deleteButtonText="삭제"
                    selectedRows={selectedRows} 
                    setSelectedRows={setSelectedRows}
                    style={{ flex: 1, minHeight: 0, width: "100%" }}
                    pageStateKey="archive.bbboard.list"
                /> 
            </div>
        </VerticalLayout>
    );
});
